import { Cirus } from "@/classes/Http";

export function findProduct(product_id: string) {
    const query = `/products/${product_id}`;
    return Cirus.get(query);
}

export function getMedias (product_id: string) {
    const query = `/product/${product_id}/medias`;
    return Cirus.get(query);
}

export function getPriceFilter (product_id: string) {
    const query = `/product/${product_id}/price-filter`;
    return Cirus.get(query);
}

export function getFilterPrices(product_id: string, filter_id: string) {
    const path = `/product/${product_id}/price-filter/${filter_id}`;
    return Cirus.get(path);
}